import { Book, BookCategories } from '@/entities/books/model/types';

type BookCategoriesMap = { [key: number]: string[] };

export const generateBookCategories = (
  booksData: Book[],
  categoriesData: BookCategories[],
): BookCategoriesMap => {
  const bookCategories: BookCategoriesMap = {};

  booksData?.forEach((book) => {
    const selectedCategories = book.categoryIds
      .map((categoryId) => {
        const category = categoriesData?.find((cat) => cat.id === categoryId);
        return category ? category.title : null;
      })
      .filter(Boolean) as string[];

    if (selectedCategories.length > 0) {
      bookCategories[book.id] = selectedCategories;
    }
  });

  return bookCategories;
};
